import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { UDF, UdfCategory, UdfOptions } from '@intellio/shared/models';
import { AppConfigService } from './app-config.service';
import { AuthService } from './auth.service';
import { BaseService } from './base-service.service';

@Injectable({
  providedIn: 'root',
})
export class AppUserService extends BaseService {
  constructor(
    protected client: HttpClient,
    protected configService: AppConfigService,
    protected authService: AuthService
  ) {
    super(client, configService, authService);
  }

  getUDFs(typeId) {
    const getUDFsUrl = '/api/applications/types/' + typeId + '/udfs';
    return this.get<UDF[]>(getUDFsUrl);
  }

  getApplicationUDFCategories() {
    const getUDFCategoriesURL = '/api/applications/udfs/categories';
    return this.get<UdfCategory[]>(getUDFCategoriesURL);
  }

  createUDFCategory(model: { displayName: string; displayOrder: number }) {
    const createUDFCategoryUrl = '/api/applications/udfs/categories';
    return this.post<UdfCategory>(createUDFCategoryUrl, model);
  }

  getUDFDropdownOptions() {
    const getUDFsUrl = '/api/applications/udfs/options';
    return this.get<UdfOptions[]>(getUDFsUrl);
  }

  createUDF(model: Record<string, unknown>) {
    const createUDFUrl = '/api/applications/udfs/' + model.id;
    return this.post<string>(createUDFUrl, model);
  }

  createUDFForApplicationType(
    applicationTypeId: string,
    udfId: string,
    model: Record<string, unknown>
  ) {
    const createUDFUrl =
      '/api/applications/types/' + applicationTypeId + '/udfs/' + udfId;
    return this.post<string>(createUDFUrl, model);
  }

  updateUDFForApplicationType(
    applicationTypeId: string,
    udfId: string,
    model: Record<string, unknown>
  ) {
    const updateUDFUrl =
      '/api/applications/types/' + applicationTypeId + '/udfs/' + udfId;
    return this.put<string>(updateUDFUrl, model);
  }

  updateUDFs(model: UDF[], appId: string) {
    const updateUDFsUrl = '/api/applications/' + appId + '/udfs';
    return this.post<string>(updateUDFsUrl, model);
  }
}
